/**
 * @generated SignedSource<<a011f9d9fd8f597247719c883e38fd20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trelloStreamDetails$data = {
  readonly doneListId: string | null;
  readonly externalBoardId: string;
  readonly externalBoardName: string;
  readonly externalListId: string;
  readonly includeAiGenerated: boolean;
  readonly organizationId: string;
  readonly trelloUser: {
    readonly id: string;
    readonly user: {
      readonly fullName: string;
    };
  };
  readonly uncheckedListId: string | null;
  readonly " $fragmentType": "trelloStreamDetails";
};
export type trelloStreamDetails$key = {
  readonly " $data"?: trelloStreamDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"trelloStreamDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "trelloStreamDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TrelloUserNode",
      "kind": "LinkedField",
      "name": "trelloUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalBoardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalListId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalBoardName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uncheckedListId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doneListId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    }
  ],
  "type": "TrelloStreamIntegrationNode",
  "abstractKey": null
};

(node as any).hash = "55582c87b87ca980dc6ab5c908d97e17";

export default node;
